'use client';

import React, { useEffect, useState } from 'react';
import { PartDetailsAndSchematicResponse } from 'types/product-diagram';
import { Image } from 'components/image';
import { CatSkeleton } from 'components/blocks-components';
import { PRODUCT_FALLBACK_IMAGE } from 'constants/common';
import { Conditional } from '@cat-ecom/pcc-components';

interface PartsDiagramMobileProps {
  partDetailsAndSchematicResponse?: PartDetailsAndSchematicResponse[];
  isEquipmentSelected?: boolean;
}

const PartsDiagramMobile: React.FC<PartsDiagramMobileProps> = ({
  partDetailsAndSchematicResponse,
  isEquipmentSelected = false
}) => {
  const [imageLoading, setImageLoading] = useState(true);
  const findItemWithGraphicSVG = (schematicItems) =>
    schematicItems.find((item) => !!item.graphicSVG) || null;
  const schematicPart = findItemWithGraphicSVG(partDetailsAndSchematicResponse);
  const hasGraphicSVG = !!schematicPart?.graphicSVG;

  useEffect(() => {
    if (schematicPart?.graphicSVG) {
      setImageLoading(false);
    } else {
      setImageLoading(true);
    }
  }, [schematicPart?.graphicSVG]);

  return (
    <div>
      <Conditional
        test={isEquipmentSelected && hasGraphicSVG}
        fallback={
          <Image
            src={PRODUCT_FALLBACK_IMAGE}
            alt="fallback-image"
            loading="lazy"
            width={311}
            height={211}
            unoptimized
          />
        }
      >
        <Conditional test={imageLoading}>
          <CatSkeleton size={'xl'} />
        </Conditional>
        <div>
          <div
            dangerouslySetInnerHTML={{
              __html: schematicPart?.graphicSVG
            }}
            className={imageLoading ? 'd-none' : 'd-block'}
            style={{ transition: 'opacity 0.3s ease' }}
          />
        </div>
      </Conditional>
    </div>
  );
};

export default PartsDiagramMobile;
